























































































































































































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from 'vue-property-decorator';

//@ts-ignore
import indicador_variables from '@/mixins/axios/indicador_variables'
//@ts-ignore
import indicador_frecuencias from '@/mixins/axios/indicador_frecuencias'
//@ts-ignore
import poa_series from '@/mixins/axios/poa_series'
//@ts-ignore
import indicador_valor_variables from '@/mixins/axios/indicador_valor_variables'
//@ts-ignore
import TablePPoa from '@/components/tables/tablev1'
//@ts-ignore
import PmdHeader from '@/components/headersSelect/pmd'
//@ts-ignore
import dependencias from '@/mixins/axios/general_secretarias'

//@ts-ignore
import departamentos from '@/mixins/axios/general_departamentos'


//@ts-ignore
import { email, required } from 'vuelidate/lib/validators';
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'


@Component({
  components: {
   /*
    Vuetable,
    VuetablePagination,*/
    
    TablePPoa
  },
  data() {
    return {
        //idmunicipio,nombre, fecha_alta, 
            // tipo, total_empleados, nombre_titular, correo, abreviacion,
  
        columnasd:[
             
            
          
             {
                tag:'idserie',
                data:'serie',
                active:true
            },
             {
                tag:'idfrecuencia',
                data:'frecuencia',
                active:true
            },
              {
                tag:'idvariable',
                data:'variable',
                active:true
            },
             {
                tag:'secretaria',
                data:'secretaria',
                active:true
            },
             {
                tag:'departamento',
                data:'departamento',
                active:true
            },
                {
                tag:'enero',
                data:'enero',
                active:true
            },
            {
                tag:'febrero',
                data:'febrero',
                active:true
            },
            {
                tag:'marzo',
                data:'marzo',
                active:true
            },
              {
                tag:'abril',
                data:'abril',
                active:true
            },
                 {
                tag:'mayo',
                data:'mayo',
                active:true
            },
            {
                tag:'junio',
                data:'junio',
                active:true
            },
            {
                tag:'julio',
                data:'julio',
                active:true
            },
              {
                tag:'agosto',
                data:'agosto',
                active:true
            },
                 {
                tag:'septiembre',
                data:'septiembre',
                active:true
            },
            {
                tag:'octubre',
                data:'octubre',
                active:true
            },
            {
                tag:'noviembre',
                data:'noviembre',
                active:true
            },
              {
                tag:'diciembre',
                data:'diciembre',
                active:true
            },
           
             {
                tag:'delete',
                data:'delete',
                active:false
            },
            {
                tag:'edit',
                data:'edit',
                active:false
            },
             
            
           
        ],




        id:null as any,

   
       idfrecuencia:0,
  idserie:0,
         idvariable:0,
      enero:0 as any,
      febrero:0 as any,
      marzo:0 as any,
   abril:0 as any,
      mayo:0 as any,
      junio:0 as any,
      julio:0 as any,
      agosto:0 as any,
      septiembre:0 as any,
   octubre:0 as any,
      noviembre:0 as any,
      diciembre:0 as any,
  idsecretaria:0,
      iddepartamento:0,
 indicador_variables:[]as any,
  indicador_frecuencias:[]as any,
   poa_series:[]as any,
     
         
         
              indicador_vvariabledata:[] as any,
      
    }
  },
     mixins: [indicador_valor_variables,indicador_variables,
     indicador_frecuencias,poa_series,departamentos,dependencias],
     validations: {
       idsecretaria: {
      required,
    },
       iddepartamento: {
      required,
    },   
     idserie: {
    
    },  
     idfrecuencia: {
    
    },  
    idvariable: {

    },
  
    enero: {
      
    },
    
    febrero: {

    },
    
    marzo: {
 
    },     
    abril: {
     
    },
    mayo: {
  
    },
    junio: {
 
    },
     julio: {
     
    },
     agosto: {
     
    },
     septiembre: {

    },
     octubre: {
   
    },
     noviembre: {
    
    },
     diciembre: {
   
    },
 
     

   
  },
  methods:{
onChange(event){
//console.log(event.target.value)
this.getDataDepartamentos(event.target.value);
},
async getDataDepartamentos(id) {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
iddependencia:id,
idmunicipio:this.$store.state.user.usuario.id_municipio

};

let data= await this.GET_GENERAL_DEPARTAMENTOS(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.departamentos=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},
      async getDataSecretarias() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio
};

let data= await this.GET_SECRETARIAS(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.dependencias=response;
this.getDataDepartamentos(response[0].id);
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},

       onChangeV(event){
//console.log(event.target.value)
this.getDataVariable(event.target.value);

},
      
       async getDataVariable(id) {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio

};

let data= await this.GET_INDICADOR_VARIABLES(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.indicador_variables=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},


       onChangeF(event){
//console.log(event.target.value)
this.getDataFrecuencia(event.target.value);

},
      
       async getDataFrecuencia(id) {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio

};

let data= await this.GET_INDICADOR_FRECUENCIA(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.indicador_frecuencias=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},





       onChangeS(event){
//console.log(event.target.value)
this.getDataSerie(event.target.value);

},
      
       async getDataSerie(id) {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio

};

let data= await this.GET_POA_SERIES(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.poa_series=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},
       
      async eliminar(row){
         
this.$root.$emit('loading', true);
let data= await this.ELIMINAR_INDICADOR_VALOR_VARIABLES(row).then(response => {

                    if (response != null) {

 this.indicador_vvariabledata=this.indicador_vvariabledata.filter(item => item.id !== row.id);
 
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar eliminar paquete, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                });
      },
  /*     select(row){

//alert('pmd seleccionado');
 //this.$store.state.pmd_sel=row;
 this.$store.commit('SETPMD',row);
           //this.secretaria_sel=row;
//this.departamentos=true;
 //this.$store.commit('SETSECRETARIA',row);
   this.$router.push('/mun/general/pmd/ejes')
//this.getDataDepartamentos();

      
     },*/
     confirm(row){

let th=this;
Notiflix.Confirm.Show('Alerta de confirmacion','Desea eliminar este elemento?','Aceptar','Cancelar',function(){ 
    
    th.eliminar(row);
    },function(){ 
      
        
    });



      
     },
      limpiar(){
this.id=null;
 this.idfrecuencia=0;
               this.idvariable=0;
                   this.idserie=0;
                     this.enero=0;
                 this.febrero=0;
                 this.marzo=0;
              this.abril=0;
                 this.mayo=0;
                 this.junio=0;
                 this.julio=0;
                 this.agosto=0;
                 this.septiembre=0;
                    this.octubre=0;
                 this.noviembre=0;
                 this.diciembre=0;
       this.idsecretaria=0;
                 this.iddepartamento=0;
           
      },
      addRow(){
          this.limpiar();
 $('#ac_modal_ValorVariable').modal('show')
      },
seteditar(row){


 this.id=row.id;
     this.idfrecuencia=row.idfrecuencia;
this.idserie=row.idserie;
         this.idvariable=row.idvariable;
        
 this.enero=row.enero;
  this.febrero=row.febrero;
   this.marzo=row.marzo;
       
 this.abril=row.abril;
  this.mayo=row.mayo;
   this.junio=row.junio;
       
 this.julio=row.julio;
  this.agosto=row.agosto;
   this.septiembre=row.septiembre;
    
 this.octubre=row.octubre;
  this.noviembre=row.noviembre;
   this.diciembre=row.diciembre;
  this.idsecretaria=row.idsecretaria;
           this.iddepartamento=row.iddepartamento;
            
          
 $('#ac_modal_ValorVariable').modal('show')
    

},
     async crear(dat){
let data= await this.CREAR_INDICADOR_VALOR_VARIABLES(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)

  this.indicador_vvariabledata.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar editar Indicador Valor Variables, refresque la pagina");

                    }    $("#ac_modal_ValorVariable").modal("hide");
 this.$root.$emit('loading', false);
                    //loading.close();
                });

      },
     async editar(dat){


let data= await this.EDITAR_INDICADOR_VALOR_VARIABLES(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)
 this.$root.$emit("success", "Indicador de areas modificado exitosamente, refresque la pagina");
  this.indicador_vvariabledata=this.indicador_vvariabledata.filter(item => item.id !== dat.id);
 this.indicador_vvariabledata.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar crear Indicador Valor Variables, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                    //loading.close();
                });


      }
     ,
     async GuardarData(){



console.log('id:'+this.id)

let dat={
  id:this.id,
     
              idfrecuencia:this.idfrecuencia,
            idserie:this.idserie,
       
              idvariable:this.idvariable,
              enero:this.enero,
                  febrero:this.febrero,
                   marzo:this.marzo,     
                    abril:this.abril,
                  mayo:this.mayo,
                   junio:this.junio,      
                   julio:this.julio,
                  agosto:this.agosto,
                   septiembre:this.septiembre,
                 octubre:this.octubre,
                  noviembre:this.noviembre,
                   diciembre:this.diciembre,
                     idsecretaria:this.idsecretaria,
                      iddepartamento:this.iddepartamento,
            idmunicipio:this.$store.state.user.usuario.id_municipio,

}
console.log(dat)
 this.$root.$emit('loading', true);
 if(this.id==null){
     this.crear(dat);
 }else{
       this.editar(dat);
 }

      },
async getData() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
    idserie:this.idserie,
idvariable:this.idvariable,
idfrecuencia:this.idfrecuencia,
idmunicipio:this.$store.state.user.usuario.id_municipio
};

let data= await this.GET_INDICADOR_VALOR_VARIABLES(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.indicador_vvariabledata=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},



  },
  mounted(){
      //this.getData();
       this.getDataSecretarias();
      this.getDataVariable();
      this.getDataFrecuencia();
      this.getDataSerie();
      //alert('10')
  }
})
export default class Home extends Vue {}

